import { render, staticRenderFns } from "./ProjectMetrics.vue?vue&type=template&id=16c0c717"
import script from "./ProjectMetrics.vue?vue&type=script&lang=js"
export * from "./ProjectMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports